import { render } from "./TaskSettingsMain.vue?vue&type=template&id=0c1c5c70"
import script from "./TaskSettingsMain.vue?vue&type=script&lang=js"
export * from "./TaskSettingsMain.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsMain.vue?vue&type=style&index=0&id=0c1c5c70&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__